import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import AdvanceTable from "../../../components/advanceTable";
import UpdateGLFields from "./components/updateGLFields";
import { SearchTypeEnum } from "../../../constants/appConstant";

const POSMachineGLFields = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [glFieldsOpen, setGlFieldsOpen] = useState(false);
  const [glFieldsId, setGlFieldsId] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!glFieldsOpen && glFieldsId) {
      setGlFieldsId(null);
    }
  }, [glFieldsOpen]);

  const getData = async () => {
    setLoading(true);
    const payload = {
      pageNumber: 1,
      recordsToDisplay: 1000,
    };
    const response = await Common.ApiService.getInstance().request(
      "GetPOSMachines",
      payload,
      "POST"
    );

    const list =
      Array.isArray(response?.data) && response.data.length > 0
        ? response.data[0]?.data ?? []
        : [];

    setData(list);
    setLoading(false);
  };

  const _onUpdateGLFields = async (id) => {
    setGlFieldsOpen(true);
    setGlFieldsId(id);
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const actions = [
    {
      type: "customIcon",
      icon: "pencil",
      onClick: (val) => _onUpdateGLFields(val.id),
    },
  ];

  const _thead = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    { title: "Name", type: "text", isVisible: true, key: "name" },
    { title: "Code", type: "text", isVisible: true, key: "code" },
    {
      title: "GL Bank MARC",
      type: "text",
      isVisible: true,
      key: "gl_bank_marc",
    },
    {
      title: "GL Bank DISC",
      type: "text",
      isVisible: true,
      key: "gl_bank_disc",
    },
    // { title: "Is Active", type: "boolean", isVisible: true, key: "isactive" },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <AdvanceTable
        title={"POS Machine GL Fields"}
        columns={_thead.filter((item) => item.isVisible)}
        data={{ data: data }}
        getData={getData}
        showPagination={false}
        showAddButton={false}
        actionButtons={actions}
        updateTrigger={_addUpdateTrigger}
        search={SearchTypeEnum.Local_Search}
        searchInputClassName="custom-search-mobile"
      />

      <UpdateGLFields
        id={glFieldsId}
        onClose={() => {
          getData();
          setGlFieldsId(null);
        }}
        open={glFieldsOpen}
        setOpen={setGlFieldsOpen}
      />
    </>
  );
};

export default POSMachineGLFields;
